module.exports = __webpack_public_path__ + "img/chum_no.124ee20e.png";